<astral-select
  [control]="control"
  [itemsSource]="itemsSource"
  [helpText]="helpText"
  [multiple]="multiple"
  [clearOthers]="clearOthers"
></astral-select>
